module.exports = "/static/assets/fc4228c3fe329628c4ba78569e5620eb.gif";